'use client';

import { c as _c } from "react/compiler-runtime";
import { ReactNode, SyntheticEvent, useCallback, useMemo } from 'react';
import { Form } from '@personly/libs-widgets';
import { useNotifications } from '@personly/libs-providers';
import type { Combinations } from '@/statics/tickets';
import { useEmails } from '@/providers/emails';
import { useTextareas } from '@/providers/textareas';
import useTickets from '@/hooks/tickets';
interface Props {
  children: ReactNode;
  combinations: Combinations;
  locale: string;
}
const TicketForm = t0 => {
  const $ = _c(12);
  const {
    children,
    combinations,
    locale
  } = t0;
  const {
    email,
    setEmail
  } = useEmails();
  const {
    textarea,
    setTextarea
  } = useTextareas();
  const {
    createNotification
  } = useNotifications();
  const {
    createTicket
  } = useTickets();
  const type = combinations[0];
  let t1;
  if ($[0] !== createNotification || $[1] !== createTicket || $[2] !== email || $[3] !== locale || $[4] !== setEmail || $[5] !== setTextarea || $[6] !== textarea || $[7] !== type) {
    t1 = e => {
      e.preventDefault();
      createTicket(email, textarea, type, locale, code => {
        setTextarea("");
        setEmail("");
        createNotification("SUCCESS", code, {}, Infinity);
      });
    };
    $[0] = createNotification;
    $[1] = createTicket;
    $[2] = email;
    $[3] = locale;
    $[4] = setEmail;
    $[5] = setTextarea;
    $[6] = textarea;
    $[7] = type;
    $[8] = t1;
  } else {
    t1 = $[8];
  }
  const handleSubmit = t1;
  let t2;
  if ($[9] !== children || $[10] !== handleSubmit) {
    t2 = <Form onSubmit={handleSubmit}>{children}</Form>;
    $[9] = children;
    $[10] = handleSubmit;
    $[11] = t2;
  } else {
    t2 = $[11];
  }
  return t2;
};
export default TicketForm;